module.exports = __webpack_public_path__ + "img/Img25_209613_DiDt-8-4N2-453.21a5aee0.jpg";